export const ComplianceMeter = {
  flow: 'y',
  gap: 'Y',
  padding: 'A',
  round: 'A',
  background: 'inkSurface',
  border: '1px solid inkBorder',
  Label: { text: (el, s) => s.label || 'Compliance', fontSize: 'Z', fontWeight: '600', color: 'inkText' },
  BarTrack: {
    width: '100%',
    height: 'Y',
    round: 'B',
    background: 'inkMid',
    overflow: 'hidden',
    BarFill: {
      height: '100%',
      round: 'B',
      width: (el, s) => (s.percentage || 0) + '%',
      transition: 'width 0.4s ease',
      background: (el, s) => {
        const p = s.percentage || 0
        if (p > 80) return 'teal'
        if (p >= 50) return 'amber'
        return 'red'
      }
    }
  },
  BottomRow: {
    flow: 'x',
    align: 'center space-between',
    Percentage: {
      text: (el, s) => (s.percentage || 0) + '%',
      fontSize: 'Z',
      fontWeight: '700',
      color: (el, s) => {
        const p = s.percentage || 0
        if (p > 80) return 'teal'
        if (p >= 50) return 'amber'
        return 'red'
      }
    },
    ItemsCount: { text: (el, s) => (s.itemsCount || '0') + ' items', fontSize: 'Y', color: 'inkMuted' }
  }
}
